// Single source of truth for turning the shared dashboard `filters` object
// into request params. For the vendor branch, financialYear and vendorCode
// are structurally dropped here regardless of what (if anything) ends up in
// `filters` — this is the actual enforcement point, not just the absent UI.
export const buildFilterParams = (filters = {}, { isVendorBranch = false } = {}) => {
  const params = {};

  if (!isVendorBranch && filters.financialYear) params.financialYear = filters.financialYear;
  if (filters.region) params.region = filters.region;
  if (filters.site) params.site = filters.site;
  if (!isVendorBranch && filters.vendorCode) params.vendorCode = filters.vendorCode;

  return params;
};
